import { createContext, useContext } from 'react';

type AssetsPageContextType = {
  /**
   * Optional: only `AssetsPage` drives it. Its non-list tabs (Backup / PII / Subscription /
   * Disposal / User Access Review) render a full-page empty screen carrying its own CTA, so
   * the page hides the header's Add button while that screen is up. Pages whose tabs are all
   * plain lists — Software, Infrastructure — have nothing to report and omit it entirely, so
   * their header always keeps its Add button. Consumers call it as `setIsTabEmpty?.(…)`.
   */
  setIsTabEmpty?: (isEmpty: boolean) => void;
  refreshToken?: number;
  /** Bumps `refreshToken`, forcing every list under this provider to refetch. */
  refreshList?: () => void;
  /**
   * Optional: only `SoftwarePage` drives it. Lets the Subscriptions tab open the page's own
   * "Add Subscription" modal from a table row — a Fleet-detected application with no tracked
   * license yet — prefilled with that application's name, instead of duplicating the modal.
   */
  openAddModal?: (prefillName?: string) => void;
};

export const AssetsPageContext = createContext<AssetsPageContextType>({});

export const useAssetsPageContext = () => useContext(AssetsPageContext);
